import { render } from "./StudentInfo.vue?vue&type=template&id=5138dd00&scoped=true"
import script from "./StudentInfo.vue?vue&type=script&lang=js"
export * from "./StudentInfo.vue?vue&type=script&lang=js"

import "./StudentInfo.vue?vue&type=style&index=0&id=5138dd00&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5138dd00"]])

export default __exports__